import { Gender } from '@constants/common.constants';

export const EMPTY_VALUE = '-';

export const GENDER_CODE_MAP: Record<string, string> = {
    M: Gender.MALE,
    F: Gender.FEMALE,
};

export const GENDER_TRANSLATION_MAP: Record<string, string> = {
    [Gender.MALE]: 'common.male',
    [Gender.FEMALE]: 'common.female',
};
